<template>
  <div>
    <div v-if="!loading">
      <div v-if="user" class="flex items-center">
        <apps-switcher />
        <ts-popover placement="bottom" width="200" trigger="click" style="margin-left: 1rem">
          <ts-button slot="reference">{{ user.full_name }}</ts-button>
          <div class="popin">
            <p><ts-link @click="handleMyAccountClick">My account</ts-link></p>
            <p><ts-link @click="handleLogoutClick">Log out</ts-link></p>
          </div>
        </ts-popover>
      </div>
      <div v-else>
        <div class="menu">
          <ts-button @click="handleSignupClick">Sign up</ts-button>
          <!-- <ts-button @click="handleSigninClick">Sign in</ts-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.menu {
  display: flex;

  > * {
    margin-left: 16px;
  }
}

.popin {
  text-align: center;

  > p {
    margin: 6px 0;
  }
}
</style>

<script>
import AppsSwitcher from './AppsSwitcher.vue';
import { appId, appCallbackRoute } from '@/api/workflow';
import { mapState, mapActions } from 'vuex';
import appSettingsProvider from '@/appsettings';

export default {
  components: { AppsSwitcher },
  computed: {
    ...mapState({
      loading: state => state.identity.loading,
      user: state => state.identity.user
    })
  },
  methods: {
    ...mapActions(['logout']),
    async handleMyAccountClick() {
      appCallbackRoute(appId())
        .then(route => {
          const appSettings = window.config('clients')[appId()];
          window.location = appSettings.profileUrl;
        })
        .catch(err => {
          this.$router.push({ name: 'my-account' }).catch(() => {});
        });
    },
    async handleLogoutClick() {
      appCallbackRoute(appId())
        .then(route => {
          const appSettings = window.config('clients')[appId()];
          const redirectTo = `${appSettings.logoutUrl}?continue=${appSettings.appUrl}`;
          localStorage.removeItem('produce-token');
          window.location = redirectTo;
        })
        .catch(err => {
          this.logout().then(() => this.$router.push({ name: 'connection' }));
        });
    },
    handleSignupClick() {
      this.$router.push({ name: 'registration' }).catch(() => {});
    },
    handleSigninClick() {
      this.$router.push({ name: 'connection' }).catch(() => {});
    }
  }
};
</script>
